import Dialog from "@components/Dialog"
import { Trans, useTranslation } from "react-i18next"

interface Props {
  onClose: () => void
  open: boolean
}

export default function ForgotPasswordDialog({ onClose, open }: Props) {
  const { t } = useTranslation()
  return (
    <Dialog dismissible={false} onClose={onClose} open={open}>
      <div className="space-y-2">
        <h2 className="heading">
          {t("pages.account.forgotPassword.dialog.title")}
        </h2>

        <p className="text-center">
          <Trans
            components={{ bold: <span className="font-semibold" /> }}
            i18nKey="pages.account.forgotPassword.dialog.text"
          />
        </p>
      </div>
    </Dialog>
  )
}
